<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm"
  >
    <el-form-item :label="$t('TYPE')" prop="type.id" v-loading="fuelLoading">
      <el-select
        :placeholder="$t('SELECT_PLACEHOLDER')"
        :collapse-tags="!ruleForm.disabled"
        clearable
        filterable
        v-model="ruleForm.type.id"
      >
        <el-option
          v-for="item in fuels"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('INSURANCE_ID')" prop="insurance_id">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        v-model="ruleForm.insurance_id"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <el-form-item :label="$t('ISSUED_DATE')" prop="issued_date">
      <date-picker
        :disabled="ruleForm.disabled"
        class="el-input__inner"
        v-model="ruleForm.issued_date"
        view="year"
        format="jYYYY-jMM-jDD"
        :locale="$i18n.locale"
        clearable
      />
    </el-form-item>

    <el-form-item :label="$t('EXPIRED_DATE')" prop="expiration_date">
      <date-picker
        :disabled="ruleForm.disabled"
        class="el-input__inner"
        v-model="ruleForm.expiration_date"
        view="year"
        format="jYYYY-jMM-jDD"
        :locale="$i18n.locale"
        clearable
      />
    </el-form-item>

    <el-form-item :label="$t('USED_QUOATA')" prop="quota_capacity_during_add">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="
          ruleForm.quota_capacity_during_add = toEnglish(
            ruleForm.quota_capacity_during_add
          )
        "
        v-model="ruleForm.quota_capacity_during_add"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <FormConfirmation
      v-show="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
      :edit="null"
      :loading="submitLoading"
    />
  </el-form>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { addInsuranceNew, editInsuranceNew, getInsuranceType } from '@/api/cars'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
export default {
  mixins: [resetForm, jalaliToGregorian, gregorianToJalali],
  props: {
    quota: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormConfirmation,
  },
  data() {
    return {
      submitLoading: false,
      fuelLoading: true,
      fuels: [],
      ruleForm: {
        insurance_id: '',
        issued_date: '',
        expiration_date: '',
        // quota_capacity_during_add: 32767,
        // added_quota_capacity: 32767,
        quota_capacity_during_add: '',
        type: {
          id: '',
        },
        disabled: this.$route.name.includes('VIEW') ? true : false,
        // description: '',
        id: null,
        // date: '',
        // fuel_card: {
        //   id: this.$route.params.id,
        // },
      },
      rules: {
        insurance_id: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('INSURANCE_ID'),
            }),
            trigger: 'blur',
          },
        ],
        type: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_CHOOSE', {
                type: this.$i18n.t('TYPE'),
              }),
              trigger: 'blur',
            },
          ],
        },
        issued_date: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('INSURANCE_ID'),
            }),
            trigger: 'blur',
          },
        ],
        expiration_date: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('EXPIRED_DATE'),
            }),
            trigger: 'blur',
          },
        ],
        quota_capacity_during_add: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('USED_QUOATA'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    quota(val) {
      if (val) {
        this.ruleForm = val
        this.ruleForm.issued_date = this.gregorianToJalali(val.issued_date)
        this.ruleForm.expiration_date = this.gregorianToJalali(
          val.expiration_date
        )
        this.ruleForm.disabled = this.$route.name.includes('VIEW')
          ? true
          : false
      }
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        // console.log()
        if (valid) {
          const actionPayload = {
            insurance_id: this.ruleForm.insurance_id,
            company_vehicle: this.$route.params.id,
            issued_date: this.jalaliToGregorian(
              this.ruleForm.issued_date,
              this.$i18n.locale
            ),
            expiration_date: this.jalaliToGregorian(
              this.ruleForm.expiration_date,
              this.$i18n.locale
            ),
            quota_capacity_during_add: this.ruleForm.quota_capacity_during_add,
            type: this.ruleForm.type.id,
          }
          var dispatchFunc =
            this.quota == null ? addInsuranceNew : editInsuranceNew

          if (this.quota) {
            actionPayload.id = this.quota.id
          }
          this.submitLoading = true
          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t('INSURANCE_INFO') + ' ' + this.$t('SUCCESSFULLY_'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              this.resetForm(formName)

              this.$emit('tableData', {
                ...actionPayload,
                mode: this.quota == null ? 'add' : 'edit',
                id: res.id,
                // added_quota_capacity: res.added_quota_capacity,
                // used_quota_capacity: res.used_quota_capacity,
                quota_capacity_during_add: res.quota_capacity_during_add,
                remaining_quota_capacity: res.remaining_quota_capacity
                  ? res.remaining_quota_capacity
                  : '',
                type: this.fuels.find((i) => i.id === res.type),
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  created() {
    getInsuranceType.api().then((res) => {
      if (res) {
        this.fuels = res
        this.fuelLoading = false
        // this.ruleForm.fuel_card.id = +this.$route.params.id
      }
    })
  },
}
</script>
